import React from "react";
import RegularText from "../common/_RegularText";
import {Button, Modal} from "../common";
import styles from "../common/_Modal/_Modal.module.scss";

const ApproveRequestModal = ({onYes, show, setShow}) => {
    return <Modal header={"requestDetails.modal.approve.header"} show={show} setShow={setShow} handleClose={() => setShow(false)}>
        <RegularText text="requestDetails.modal.approve.message"/>
        <Modal.Footer>
            <Button label={"requestDetails.modal.approve.noButton"} variant={"secondary"}
                    onClick={() => setShow(false)}/>
            <Button label={"requestDetails.modal.approve.yesButton"} variant={"success"}
                    onClick={() => onYes()} className={styles.submitButton}/>
        </Modal.Footer>
    </Modal>
};
export {ApproveRequestModal};